import '@fontsource/roboto'
import Layout from './components/Common/Layout'
import Authentication from './pages/authentication'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import MapViewPage from './pages/MapView'
import WeekView from './pages/WeekView'
import GalleryView from './pages/GalleryView'

function App() {
  return (
    <Router>
      <div className='App'>
        <Switch>
          <Route path='/' exact>
            <Authentication />
          </Route>
          <Route path='/map-view' exact>
            <Layout>
              <MapViewPage />
            </Layout>
          </Route>
          <Route path='/week-view' exact>
            <Layout>
              <WeekView />
            </Layout>
          </Route>
          <Route path='/gallery-view' exact>
            <Layout>
              <GalleryView />
            </Layout>
          </Route>
        </Switch>
      </div>
    </Router>
  )
}

export default App
